'use client';

import { useEffect, useRef } from 'react';

const CQCWidget = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const container = containerRef.current;

    const script = document.createElement('script');
    script.src =
      'https://www.cqc.org.uk/sites/all/modules/custom/cqc_widget/widget.js?data-id=1-19680665038&data-host=https://www.cqc.org.uk&type=location';
    script.type = 'text/javascript';
    script.async = true;

    container.appendChild(script);

    return () => {
      container.innerHTML = '';
    };
  }, []);

  return <div ref={containerRef} />;
};

export default CQCWidget;
